import { render, staticRenderFns } from "./ManagePromoCodes.vue?vue&type=template&id=0de24c51&scoped=true"
import script from "./ManagePromoCodes.vue?vue&type=script&lang=js"
export * from "./ManagePromoCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de24c51",
  null
  
)

export default component.exports